import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { formatIsoDate } from 'utils/dateFormatter';
import AddMealToFavoritesMutation from './AddMealToFavoritesMutation';
import FavMealsQuery from '../Fetch/FavMealsQuery';

const AddMealToFavoritesConnectorApollo = ({ children }) => {
    const [addMealToFav, { data, loading, error }] = useMutation(
        AddMealToFavoritesMutation,
        {
            refetchQueries: [
                {
                    query: FavMealsQuery,
                    variables: {
                        text: '',
                        date: formatIsoDate(new Date()),
                    },
                },
            ],
        }
    );

    const createAddMealToFavorites = async mealId => {
        const response = await addMealToFav({
            variables: { mealId },
        });

        return response;
    };

    return children({
        addMealToFavorites: {
            addMeal: createAddMealToFavorites,
            response: data,
            loading,
            error,
        },
    });
};

AddMealToFavoritesConnectorApollo.propTypes = {
    children: PropTypes.func.isRequired,
};

export default AddMealToFavoritesConnectorApollo;
